





































import { Component, Prop, Vue } from 'vue-property-decorator'

export enum OzListRowSeparator {
  None = 'none',
  Short = 'short',
  Long = 'long',
  FullWidth = 'full-width',
}

@Component({})
export default class OzListRow extends Vue {
  Separator = OzListRowSeparator

  /**
   * Separator type
   */
  @Prop({ default: OzListRowSeparator.Short }) separator!: OzListRowSeparator

  /**
   * Dark mode
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  /**
   * Set to false if list is for display only.
   */
  @Prop({ default: true }) clickable!: boolean

  get xSeparator(): boolean {
    return this.separator !== 'none'
  }

  get lineSeparatorClass(): Record<string, boolean> {
    const colorClasses = {
      'after:bg-divider-gray dark:after:bg-divider-gray-dark': this.darkMode === 'auto',
      'after:bg-divider-gray': this.darkMode === false,
      'after:bg-divider-gray-dark': this.darkMode === true,
    }
    return {
      'after:absolute': true,
      'after:h-px': true,
      'after:bottom-[-4px]': true,
      ...colorClasses,
    }
  }
}
